"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectToggler = exports.mapTreatmentToProps = exports.mapIsFeatureOnToProps = void 0;
var tslib_1 = require("tslib");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var selectors_1 = require("../selectors");
var constants_1 = require("../constants");
var NullRenderComponent = function () { return null; };
/**
 * To avoid passing down dispatch property, merge props override default
 * behaviour from connect. Here dispatchProps are not passing down.
 *
 * @param {any} stateProps
 * @param {any} dispatchProps
 * @param {any} ownProps
 */
var mergeProps = function (stateProps, dispatchProps, ownProps) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, stateProps), ownProps)); };
/**
 *  This toggler just returns a react component that decides which component to render
 * regarding it props.
 *
 * @param {React.ComponentType} ComponentOn
 * @param {React.ComponentType} ComponentDefault
 */
var toggler = function (ComponentOn, ComponentDefault) {
    if (ComponentDefault === void 0) { ComponentDefault = NullRenderComponent; }
    return function (_a) {
        var isFeatureOn = _a.isFeatureOn, props = (0, tslib_1.__rest)(_a, ["isFeatureOn"]);
        return isFeatureOn ? ((0, react_1.createElement)(ComponentOn, props)) : ((0, react_1.createElement)(ComponentDefault, props));
    };
};
/**
 * Looks on the features of the Split piece of state, and maps to isFeatureOn
 * depending if this feature is ON or not
 *
 * @param {string} featureFlagName feature flag name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
function mapIsFeatureOnToProps(featureFlagName, key, getSplitState) {
    if (getSplitState === void 0) { getSplitState = selectors_1.defaultGetSplitState; }
    return function (state) {
        var splitState = getSplitState(state);
        return {
            isFeatureOn: (0, selectors_1.selectTreatmentValue)(splitState, featureFlagName, key) === constants_1.ON,
        };
    };
}
exports.mapIsFeatureOnToProps = mapIsFeatureOnToProps;
/**
 * Looks on the features of the Split piece of state, and maps to feature
 * the value of this feature
 *
 * @param {string} featureFlagName feature flag name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
function mapTreatmentToProps(featureFlagName, key, getSplitState) {
    if (getSplitState === void 0) { getSplitState = selectors_1.defaultGetSplitState; }
    return function (state) {
        var splitState = getSplitState(state);
        return {
            feature: (0, selectors_1.selectTreatmentValue)(splitState, featureFlagName, key),
        };
    };
}
exports.mapTreatmentToProps = mapTreatmentToProps;
/**
 *
 * Returns a connected component that wraps the toggler
 * The idea of this is to send the isFeatureOn prop to the toggler
 *
 * So connect send the global state and the toggler decide which to render
 *
 * @param {string} featureFlagtName feature flag name
 * @param {SplitIO.SplitKey} key user key
 * @param {IGetSplitState} getSplitState function that extract the Split piece of state from the Redux state.
 */
function connectToggler(featureFlagName, key, getSplitState) {
    if (getSplitState === void 0) { getSplitState = selectors_1.defaultGetSplitState; }
    return function (ComponentOn, ComponentDefault) {
        return (0, react_redux_1.connect)(mapIsFeatureOnToProps(featureFlagName, key, getSplitState), null, mergeProps)(toggler(ComponentOn, ComponentDefault));
    };
}
exports.connectToggler = connectToggler;
